(function () {
  window.utag_cfg_ovrd = { noview: true };
  window.utag_data = { site_type: 'single_page' };
  window.tealium = {
    profile: process.env.REACT_APP_TEALIUM_PROFILE,
    environment: process.env.REACT_APP_TEALIUM_ENVIRONMENT,
  };

  window.HSBC = window.HSBC || {};
  window.HSBC.SITE = window.HSBC.SITE || {};
  window.HSBC.PAGE = window.HSBC.PAGE || {};
  window.HSBC.EXT = window.HSBC.EXT || {};
  window.HSBC.LOG = window.HSBC.LOG || {};
  window.HSBC.DCS = window.HSBC.DCS || {};

  (function () {
    var src = `//tags.tiqcdn.com/utag/hsbc/${window.tealium.profile}/${window.tealium.environment}/utag.sync.js`;
    var script = document.createElement('script');
    script.src = src;
    document.head.appendChild(script);
  })();

  (function () {
    var src = `//tags.tiqcdn.com/utag/hsbc/${window.tealium.profile}/${window.tealium.environment}/utag.js`;
    var script = document.createElement('script');
    script.src = src;
    script.type = 'text/javascript';
    script.async = true;
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  })();
})();
